import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import API from "./api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import img_entreprise from "../assets/Images/Logo_entreprise-removebg-preview.webp";
import {
  faFacebook,
  faGithub,
  faGoogle,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEye,
  faEyeSlash,
  faEnvelope,
  faMobile,
} from "@fortawesome/free-solid-svg-icons";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import {
  Form,
  Button,
  FormControl,
  Spinner,
  InputGroup,
} from "react-bootstrap";
import "../../Styles/Login.css";
import { useSocialAuth } from "../../Hooks/UseSocialAuth";
import Flag from 'react-world-flags';
import AuthSwitch from "./AuthSwitch";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';


// Préfixes béninois valides
const PREFIXES_BENIN = [
  // MTN: 
  "42", "46", "50", "51", "52", "53", "54", "56", "57", "59", "61", "62", "66", "67", "69", "90", "91", "96", "97",
  // MOOV: 
  "55", "58", "60", "63", "64", "65", "68", "94", "95", "98", "99",
  // CELTIIS
  "40", "41", "43", "44", "47",

];

const Login = () => {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [modeEmail, setModeEmail] = useState(true);
  const [errors, setErrors] = useState({});
  const [phone, setPhone] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    value = value.slice(0, 10);
    value = value.replace(/(\d{2})(?=\d)/g, "$1 ");
    setPhone(value);
    setErrors({});
  };

  const handleNavigateHome = () => navigate("/");

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const { handleSocialLogin } = useSocialAuth();


  const toggleMode = () => {
    setModeEmail(!modeEmail);
    setErrors({});
    if (!modeEmail) setEmail("");
    else setPhone("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const newErrors = {};
    const emailRegex = /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    const cleanPhone = phone.replace(/\s/g, "");

    //  Validation email ou téléphone
    if (modeEmail) {
      if (!email.trim()) {
        newErrors.email = "Veuillez entrer un email";
      } else if (!emailRegex.test(email)) {
        newErrors.email = "L'email est invalide";
      }
    } else {
      if (!cleanPhone.trim()) {
        newErrors.phone = "Veuillez entrer un numéro de téléphone";
      } else if (!/^01\d{8}$/.test(cleanPhone)) {
        newErrors.phone = "Le numéro doit commencer par 01 et contenir 10 chiffres";
      } else {
        //  Validation stricte par préfixe béninois
        const prefix = cleanPhone.substring(2, 4);
        if (!PREFIXES_BENIN.includes(prefix)) {
          newErrors.phone = "Numéro invalide. Vérifiez votre opérateur (MTN ou Moov)";
        }
      }
    }

    // Validation mot de passe 
    if (!password) {
      newErrors.password = "Veuillez entrer votre mot de passe";
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoading(false);
      return;
    }

    try {
      const cleanPhone = phone.replace(/\s/g, "");
      const userInput = {
        email: modeEmail ? email : null,
        phone: !modeEmail ? cleanPhone : null,
        password: password,
      };
      const res = await API.post("/login", userInput);
      localStorage.setItem("token", res.data.token);
      toast.success("Connexion réussie");
      navigate("/", { replace: true });
    } catch (err) {
      if (err.response?.status === 404) {
        toast.error(err.response.data.error);
      } else if (err.response?.status === 422) {
        toast.error(err.response?.data?.message || "Une erreur est survenue");
      } else {
        toast.error("Identifiants invalides ou erreur serveur");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="connexion_form">
      <div className="container-fluid">
        <div className="row">
          <div className="offset-md-3 col-md-6 col-12">
            <div className="formulaire_connexion my-5 p-3">

              <ul
                className="d-flex flex-row list-unstyled gap-2"
                style={{ color: "#0066BD", cursor: "pointer" }}
                onClick={handleNavigateHome}
              >
                <li><HomeOutlinedIcon /></li>
                <li>Accueil</li>

              </ul>

              <div className="en-tête d-flex flex-column align-items-center">
                <img src={img_entreprise} alt="Entreprise Logo" style={{ height: "50px" }} className="my-2" />
                <AuthSwitch />
                <h6 className="Subtitle_register m-2">
                  Bienvenu sur la page de connexion de Nol Market.
                  Connectez-vous pour accéder à toutes les fonctionnalités
                </h6>
              </div>

              <Form className="formulaire_connexion_content" method="post" onSubmit={handleSubmit}>

                {/* EMAIL ou TÉLÉPHONE */}
                {modeEmail ? (
                  <div className={`field-group ${errors?.email ? "has-error" : ""} ${email ? "has-value" : ""}`}>
                    <span className="field-label">Email</span>
                    <div className="input-group">
                      <Form.Control
                        type="text"
                        value={email}
                        className="input_register"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <Button variant="outline-secondary" onClick={toggleMode} title="Utiliser un numéro">
                        <FontAwesomeIcon icon={faMobile} />
                      </Button>
                    </div>
                    {errors?.email && <div className="field-error">{errors.email}</div>}
                  </div>
                ) : (
                  <div className={`field-group has-prefix ${errors?.phone ? "has-error" : ""} ${phone ? "has-value" : ""}`}>
                    <span className="field-label">Numéro de téléphone</span>
                    <div className="input-group">
                      <InputGroup.Text className="phone-prefix">
                        <Flag code="BJ" style={{ width: "20px" }} />
                        +229
                      </InputGroup.Text>
                      <Form.Control
                        type="tel"
                        // placeholder="01 XX XX XX XX"
                        className="input_register"
                        value={phone}
                        onChange={handleChange}
                        style={{ borderLeft: "none" }}
                      />
                      <Button variant="outline-secondary" onClick={toggleMode} title="Utiliser un email">
                        <FontAwesomeIcon icon={faEnvelope} />
                      </Button>
                    </div>
                    {errors?.phone && <div className="field-error">{errors.phone}</div>}
                  </div>
                )}

                {/* MOT DE PASSE */}
                <div className={`field-group ${errors?.password ? "has-error" : ""} ${password ? "has-value" : ""}`}>
                  <span className="field-label">Mot de passe</span>
                  <div className="input-group">
                    <FormControl
                      type={showPassword ? "text" : "password"}
                      className="input_register"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button variant="outline-secondary" onClick={togglePasswordVisibility}>
                      <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                    </Button>
                  </div>
                  {errors?.password && <div className="field-error">{errors.password}</div>}
                </div>
                <p className="text-end mb-2">
                  <Link to="/forgot-password" style={{ color: "#0066BD", fontWeight: "bold" }}>
                    Mot de passe oublié ?
                  </Link>
                </p>

                <Button
                  className="button_login w-100 mt-3 mb-3"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? <Spinner size="sm" animation="border" /> : "Se connecter"}
                </Button>
              </Form>

              <p className="link_connexion_register d-flex justify-content-center mt-2">
                N'avez-vous pas de compte ?{" "}
                <span style={{ fontWeight: "bold", color: "blue" }}>
                  <Link to="/register"> Inscrivez-vous !!</Link>
                </span>
              </p>

              <div className="container">
                <div className="row h-auto d-flex align-items-center">
                  <hr className="col-5" style={{ color: "#FA7F1B", height: "1rem" }} />
                  <p className="col-2 text-center" style={{ color: "#0066BD", fontWeight: "bold" }}>
                    OU
                  </p>
                  <hr className="col-5" style={{ color: "#FA7F1B", height: "1rem" }} />
                </div>
              </div>

              <div className="register_reseaux_sociaux d-flex justify-content-center">
                <div className="social social-google m-2">
                  <FontAwesomeIcon icon={faGoogle} onClick={() => handleSocialLogin("google")} />
                </div>
                <div className="social social-facebook m-2 d-flex align-items-center">
                  <FontAwesomeIcon icon={faFacebook} onClick={() => handleSocialLogin("facebook")} />
                </div>
                <div className="social social-github m-2">
                  <FontAwesomeIcon icon={faGithub} onClick={() => handleSocialLogin("github")} />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;